"use client";

import { useContext, useEffect, useState } from "react";
import Featured from "../Featured";
import { LanguageContext } from "@/context/languageContext";
import { FeaturedComponent } from "@/types/modules";
import { HomepageOptions } from "@/types/wordpress";

interface ModuleFeaturedProps {
  homepageOptions: HomepageOptions;
}

export default function ModuleFeatured({
  homepageOptions,
}: ModuleFeaturedProps) {
  const { language } = useContext(LanguageContext);
  const [data, setData] = useState(
    language === "en"
      ? homepageOptions.moduleFeatured
      : homepageOptions.moduleFeaturedDE
  );

  useEffect(() => {
    setData(
      language === "en"
        ? homepageOptions.moduleFeatured
        : homepageOptions.moduleFeaturedDE
    );
  }, [
    homepageOptions.moduleFeatured,
    homepageOptions.moduleFeaturedDE,
    language,
  ]);

  const featured: FeaturedComponent = {
    backgroundColor: data.featured.backgroundColor,
    title: data.featured.title,
    custom: data.featured.custom,
  };

  return <Featured featured={featured} />;
}
